export default "__VITE_ASSET__mkZOFKOxXbimvLVEFNitTQ__"